import React from 'react';
import Tilt from 'react-parallax-tilt';
import { Reveal, SectionHeading } from '../SectionHeading';
import { INDUSTRIES } from '../../data/siteData';

export const IndustriesSection = () => (
  <section id="industries" data-testid="industries-section" className="py-20 md:py-32 bg-white">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <SectionHeading
        label="Industries We Serve"
        title="Deep Execution Experience Across 8 Industries"
        subtitle="Sector-specific playbooks, trained talent pools and proven delivery models."
      />
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {INDUSTRIES.map((ind, i) => (
          <Reveal key={ind.name} delay={i * 0.06}>
            <Tilt tiltMaxAngleX={7} tiltMaxAngleY={7} scale={1.02} transitionSpeed={1600} className="h-full">
              <div
                data-testid={`industry-card-${i}`}
                className="group relative h-full p-7 rounded-lg bg-[#0A192F] overflow-hidden border border-white/5 hover:border-[#4DA3FF]/40 transition-colors duration-300"
              >
                <div className="absolute -top-10 -right-10 w-32 h-32 rounded-full bg-[#0066CC]/15 blur-2xl group-hover:bg-[#0066CC]/30 transition-colors duration-500" />
                <div className="relative">
                  <div className="w-12 h-12 rounded-md bg-white/5 border border-white/10 flex items-center justify-center mb-5 group-hover:scale-110 transition-transform duration-300">
                    <ind.icon className="w-5 h-5 text-[#4DA3FF]" />
                  </div>
                  <h3 className="text-white font-semibold font-heading">{ind.name}</h3>
                  <p className="text-sm text-slate-400 mt-2 leading-relaxed">{ind.desc}</p>
                  <div className="mt-5 flex flex-wrap gap-2">
                    {ind.solutions.map((s) => (
                      <span key={s} className="text-[11px] font-medium px-2.5 py-1 rounded-full bg-[#4DA3FF]/10 border border-[#4DA3FF]/20 text-[#7CC0FF]">
                        {s}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            </Tilt>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
